import { format } from 'date-fns';

import { BffBrandType } from '@/gqlConstants';
import { getGraphHeaders } from '@/utils/getGraphHeaders';
import { logWarning } from '@/utils/miscUtils';
import { BffAvailabilityByLocationQuery } from '@/graphql/__generated/sdk';

export const getBffAvailabilityByLocation = async (
	brand: BffBrandType,
	facilityId: string,
	url: string,
	appName: string,
	appVersion: string
): Promise<BffAvailabilityByLocationQuery | null> => {
	const today = new Date();
	const nextDay = new Date(today);
	nextDay.setDate(today.getDate() + 2); // format: 2025-06-24

	try {
		if (!brand) {
			return null;
		}
		const { getGraphQLClient } = await import(
			/* webpackChunkName:"getGraphQLClient" */ '../graphql/getGraphQLClient'
		);

		const variables = {
			brand,
			facilityId,
			appointmentTypes: ['ROUTINE_CHECKUP', 'SICK_URGENT'],
			dateFrom: format(today, 'yyyy-MM-dd'),
			dateTo: format(nextDay, 'yyyy-MM-dd'),
		};
		const headers = getGraphHeaders(appName, appVersion);
		return await getGraphQLClient(url).bffAvailabilityByLocation(variables, headers);
	} catch (err) {
		logWarning(
			`MISSING_AVAILABILITY_RESULTS: ${brand} for query. Error: ${
				err instanceof Error ? err.message : String(err)
			}`
		);
		return null;
	}
};
